module.exports = __webpack_public_path__ + "a1f9829ddcc650adc57c72f16ba17fe5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CF.svg
// module id = ccvu
// module chunks = 0